module.exports = __webpack_public_path__ + "img/banner.11e4217c.png";